<div class="module-container" *ngIf="auction$ | async as auction">
  <h2>{{ 'AUTH.LOGIN.HEADER' | translate }}</h2>
  <mat-card>
    <mat-card-content>
      <div *ngIf="displaySocialLogin$ | async" class="gb-social-login-container">
        <gb-social-login-register [dialog]="false" [redirectHome]="true"></gb-social-login-register>
      </div>

      <gb-login-form [dialog]="false" [redirectHome]="true"></gb-login-form>

      <div class="help-links">
        <p>
          <a class="link mat-body-1" translate="FORGOT_PASSWORD" routerLink="../forgot-password"> </a>
        </p>
        <p>
          <a class="link mat-body-1" translate="NEED_AN_ACCOUNT" routerLink="../register"> </a>
        </p>
        <p>
          <a class="link mat-body-1" translate="GO_TO_VERIFICATION" routerLink="../verify"> </a>
        </p>
        <p>
          <a class="link mat-body-1" translate="GO_TO_PRIVACY_POLICY" (click)="openPrivacyPolicy()"> </a>
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
